import React from 'react';
import { Box } from '@tapresearch/ui/components';
import { Skeleton } from '@chakra-ui/react';
import { OpacityTransitionBox } from '../../../shared/OpacityTransitionBox';

export function MultipleSkeletonLoader({ numItems }: { numItems: number }) {
  return (
    <OpacityTransitionBox padding="6" data-testid="multiple-skeleton-loader">
      {Array(numItems)
        .fill(0)
        .map((_, i) => {
          return (
            <Box mb="6" key={`skeleton-${i}`}>
              <Skeleton h="80px" />
            </Box>
          );
        })}
    </OpacityTransitionBox>
  );
}
